import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import Error from '../../Components/Common/Error';
import Loader from '../../Components/Common/Loader';
import { getClientLicenseList } from '../../slices/LicenseList/thunk';
import AddLicenseModal from '../../Components/ManageLicense/AddLicenseModal';
import { deleteClientLicenseAPI } from '../../apiConfig/apiCall';
import { toast } from 'react-toastify';
import ViewLicenseModal from '../../Components/ManageLicense/ViewLicenseModal';
import EditStatusModal from '../../Components/ManageLicense/EditStatusModal';
import EditLicenseModal from '../../Components/ManageLicense/EditLicenseModal';
import Swal from 'sweetalert2';
import BasicTable from '../../Components/ReactTable/BasicTable';

export default function ManageLicense() {

    const params = useParams();
    const dispatch = useDispatch();
    const { isLoading, isError, data } = useSelector((state) => state.LicenseList);

    const [filtering, setFiltering] = useState('');
    const [pageSize, setPageSize] = useState(10);

    // Add License Modal
    const [addLicenseModal, setAddLicenseModal] = useState(false);

    // View License Modal
    const [viewLicenseModal, setViewLicenseModal] = useState(false);
    const [licenseData, setLicenseData] = useState({});

    // Edit License Status Modal
    const [editStatusLicenseModal, setEditStatusLicenseModal] = useState(false);
    const [licenseDataForStatus, setLicenseDataForStatus] = useState({});

    // Edit License Modal
    const [editLicenseModal, setEditLicenseModal] = useState(false);
    const [licenseDataForEdit, setLicenseDataForEdit] = useState({});


    useEffect(() => {
        dispatch(getClientLicenseList(params.id));
    }, [dispatch, params.id, pageSize]);

    if (isLoading) return <Loader />;
    if (isError) return <Error />;

    const columns = [
        {
            header: 'S.No',
            accessorKey: 'id',
            cell: ({ row }) => <span className="fw-semibold">{row.index + 1}</span>,
            enableSorting: false,
        },
        { header: 'Product Name', accessorKey: 'productName' },
        { header: 'Type', accessorKey: 'type' },
        {
            header: "Status",
            accessorKey: "status",
            cell: ({ row }) => (
                <span
                    style={{
                        color: row.original.status === 'ACTIVE' ? 'green' : 'red',
                    }}
                >
                    {row.original.status}
                </span>
            ),
        },
        { header: 'Entry By', accessorKey: 'entryBy' },
        { header: 'Entry Date', accessorKey: 'entryDate' },
        { header: 'Start Date', accessorKey: 'startDate' },
        { header: 'Due Date', accessorKey: 'dueDate' },
        {
            header: 'Actions',
            accessorKey: 'actions',
            cell: ({ row }) => (
                <div className="d-flex align-items-center gap-2">
                    <div
                        onClick={() => handleDelete(row.original.id)}
                        className="text-danger bg-danger-subtle fs-11 cursor-pointer"
                        style={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="bx bxs-trash-alt"></i>
                    </div>

                    <div
                        onClick={() => handleViewLicenseModal(row.original)}
                        className="text-info bg-info-subtle fs-11 cursor-pointer"
                        style={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="ri-eye-line"></i>
                    </div>

                    <div
                        onClick={() => handleEdit(row.original)}
                        className="text-warning bg-warning-subtle fs-11 cursor-pointer"
                        style={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="ri-edit-fill"></i>
                    </div>

                    {/* <div
                        onClick={() => handleStatusEdit(row.original)}
                        className="text-primary bg-primary-subtle fs-11 cursor-pointer"
                        style={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="ri-more-fill"></i>
                    </div> */}
                </div>
            ),
            enableSorting: false,
        },
    ];

    // Add License Fnc
    const handleAddLicenseModal = async () => {
        setAddLicenseModal(!addLicenseModal);
    }

    // View License Fnc
    const handleViewLicenseModal = async (DATA) => {
        setLicenseData(DATA);
        setViewLicenseModal(!viewLicenseModal);
    }

    const handleDelete = async (ID) => {
        try {
            const result = await Swal.fire({
                width: '20rem',
                title: 'Are you sure?',
                text: 'You won’t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {
                const apiResponse = await deleteClientLicenseAPI(ID);
                if (apiResponse.status === 200) {
                    dispatch(getClientLicenseList(params.id));
                    toast.success(apiResponse.data);
                } else {
                    toast.error(apiResponse.data);
                }

                Swal.fire({
                    width: '20rem',
                    title: 'Deleted!',
                    text: 'Your record has been deleted',
                    icon: 'success',
                });
            } else {
                Swal.fire({
                    width: '20rem',
                    title: 'Cancelled!',
                    text: 'Your record is safe',
                    icon: 'info',
                });
            }
        } catch (error) {
            console.log(error);
            Swal.fire('Error!', 'Something went wrong.', 'error');
        }
    }

    const handleEdit = async (DATA) => {
        setLicenseDataForEdit(DATA);
        setEditLicenseModal(!editLicenseModal);
    }
    const handleStatusEdit = async (DATA) => {
        setLicenseDataForStatus(DATA);
        setEditStatusLicenseModal(!editStatusLicenseModal);
    }

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Manage License" pageTitle="Dashboard" />
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="border-0 py-1">
                                <Row className="align-items-center">
                                    <div className="col-sm">
                                        <div className="d-flex align-items-center">
                                            <h5 className="card-title mb-0">License List</h5>
                                            <ButtonGroup className="material-shadow ms-2">
                                                <UncontrolledDropdown>
                                                    <DropdownToggle
                                                        tag="button"
                                                        className="btn p-1 btn-sm btn-light material-shadow-none"
                                                        style={{
                                                            fontSize: '.7rem',
                                                        }}
                                                    >
                                                        {pageSize} <i className="mdi mdi-chevron-down"></i>
                                                    </DropdownToggle>
                                                    <DropdownMenu style={{ minWidth: '100%' }}>
                                                        {[10, 20, 50, 100].map((size) => (
                                                            <DropdownItem
                                                                key={size}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '0.2rem',
                                                                    fontSize: '.7rem',
                                                                }}
                                                                onClick={() => setPageSize(size)}
                                                            >
                                                                {size}
                                                            </DropdownItem>
                                                        ))}
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </ButtonGroup>
                                        </div>
                                    </div>
                                    <div className="col-sm-auto">
                                        <div className="d-flex">
                                            <input
                                                className="form-control me-2"
                                                type="text"
                                                placeholder="Search..."
                                                value={filtering}
                                                onChange={(e) => setFiltering(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    height: '28px',
                                                    fontSize: '.7rem',
                                                    borderRadius: '.2rem',
                                                }}
                                            />
                                            <Button
                                                type="button"
                                                className="btn-sm btn-success"
                                                onClick={handleAddLicenseModal}
                                                style={{
                                                    width: '70%',
                                                    height: '28px',
                                                    fontSize: '.7rem',
                                                    borderRadius: '.2rem',
                                                }}
                                            >
                                                <i className="ri-add-line align-bottom me-1"></i>
                                                Add License
                                            </Button>
                                        </div>
                                    </div>
                                </Row>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <BasicTable
                                    columns={columns}
                                    data={data}
                                    customPageSize={pageSize}
                                    filtering={filtering}
                                    setFiltering={setFiltering}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <AddLicenseModal addLicenseModal={addLicenseModal} handleAddLicenseModal={handleAddLicenseModal} />
            <ViewLicenseModal licenseData={licenseData} handleViewLicenseModal={handleViewLicenseModal} viewLicenseModal={viewLicenseModal} />
            <EditStatusModal editStatusLicenseModal={editStatusLicenseModal} handleStatusEdit={handleStatusEdit} licenseData={licenseDataForStatus} />
            <EditLicenseModal editLicenseModal={editLicenseModal} handleEdit={handleEdit} licenseData={licenseDataForEdit} setEditLicenseModal={setEditLicenseModal} />
        </div>
    );
}